import { updateLocationForManageUsers } from './update-location-for-manage-users';
import { updateLocationForSharedRoom } from './update-location-for-shared-room';
export default {
    updateLocationForManageUsers,
    updateLocationForSharedRoom,
};
